import { render, staticRenderFns } from "./altimetria.vue?vue&type=template&id=67279aee"
import script from "./altimetria.vue?vue&type=script&lang=js"
export * from "./altimetria.vue?vue&type=script&lang=js"
import style0 from "./altimetria.vue?vue&type=style&index=0&id=67279aee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports